import { Descriptions } from 'antd';
import type { AnalyticsResponse } from '@mygate/common';
import { integer } from './AnalyticsPrimitives';

export function AnalyticsCoverage({ data }: { data: AnalyticsResponse }) {
  const coverage = data.coverage;
  return (
    <details className="analytics-source-details">
      <summary>
        Datengrundlage · {coverage.freshUsers} von {coverage.eligibleTradevestUsers} Accounts erfasst
      </summary>
      <Descriptions size="small" column={{ xs: 1, sm: 2, lg: 3 }}>
        <Descriptions.Item label="Accounts insgesamt">{integer.format(coverage.totalAccounts)}</Descriptions.Item>
        <Descriptions.Item label="Fehlende Snapshots">
          {coverage.eligibleTradevestUsers - coverage.snapshotUsers}
        </Descriptions.Item>
        <Descriptions.Item label="Zu alte Snapshots">{coverage.snapshotUsers - coverage.freshUsers}</Descriptions.Item>
        <Descriptions.Item label="Ungültige Positionen">{coverage.invalidPositions}</Descriptions.Item>
      </Descriptions>
      <dl className="analytics-definitions">
        <dt>Abdeckung</dt>
        <dd>
          Wertpapierbestände bei {coverage.missingSecuritiesUsers} Accounts nicht erfasst, Kryptobestände bei{' '}
          {coverage.missingCryptoUsers}. {coverage.unpricedPositions} Positionen ohne Marktpreis. Externe Depots fehlen.
        </dd>
        <dt>Anlagevolumen</dt>
        <dd>Gespeicherte Marktwerte bewerteter Positionen, ohne Cash, keine Live-Kurse.</dd>
        <dt>Stichtag</dt>
        <dd>
          Je Account der letzte Snapshot, höchstens {coverage.maxSnapshotAgeHours} Stunden alt. Bekannte Demo-Accounts
          sind ausgeschlossen.
        </dd>
      </dl>
    </details>
  );
}
